import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class UBXSvgService {
    url = 'http://aedevelopment-space.github.io/icons';

    constructor(
        private http: HttpClient,
    ) { }

    getIcons(cat: string, icn: string, shp: string, wgh: string) {
        shp = shp ? `.${shp}` : '';
        wgh = wgh ? `.${wgh}` : '';
        const url = `${this.url}/${cat}/${icn}${shp + wgh}.svg`;
        return this.http.get(url, { responseType: 'text' });
    }
}
